import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import React from "react";
import {
  completeDocumentStep,
  setStepDocumentsEdited,
} from "../../../../../../store/redux/slice/Forms/seVerLetterForm";
import DocumentsForm from "../../../common/form/document/DocumentsForm";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import useStepDocuments from "../../../../../../hooks/useStepDocuments";
import { fileGroups } from "../../../../../../config/fileGroupConfig";
import { ApplicationSubtype, ApplicationType } from "@duosoftbg/nacid-components";
import { Box } from "@mui/material";

const SEVerLetterStepDocuments = () => {
  const seVerLetterForm = useAppSelector((state) => {
    return state.Forms.SEVerLetterForm;
  });

  const { methods, onSubmit } = useStepDocuments(
    seVerLetterForm,
    baseEndpointPaths.seRecognition,
    completeDocumentStep,
    setStepDocumentsEdited,
  );

  useFormReset(ApplicationSubtype.SE_RECOGNITION, seVerLetterForm.documentDetails, methods.reset);

  return (
    <DocumentsForm
      methods={methods}
      onSubmit={onSubmit}
      setDocumentsFormEdited={setStepDocumentsEdited}
      hasAttachmentForm={true}
      hasAttachmentType={true}
      applicationId={seVerLetterForm.id}
      fileGroup={fileGroups.pdf}
      applicationType={ApplicationType.SE_RECOGNITION}
      applicationSubType={ApplicationSubtype.SE_RECOGNITION}
      informingMessageCode={["m.rudi.files.info", "m.seServices.applications.info"]}
    />
  );
};
export default SEVerLetterStepDocuments;
